import * as React from "react";

function IcFlagCircularEn(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      data-id="IcFlagCircularEn"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <rect width={24} height={24} />
        <g fillRule="nonzero" transform="translate(2 2)">
          <path
            fill="#00247D"
            d="M0,10 C0,4.4771525 4.47593818,0 10,0 L10,0 C15.5228475,0 20,4.47593818 20,10 L20,10 C20,15.5228475 15.5240618,20 10,20 L10,20 C4.4771525,20 0,15.5240618 0,10 L0,10 Z"
          />
          <polygon
            fill="#FFF"
            points="3 17 10 11.5 17 17 19 15 12.5 10 19 5 17 3 10 8.5 3 3 1 5 7.5 10 1 15"
          />
          <path
            fill="#CF142B"
            d="M10,9 L10.1666667,9.125 L17,4 L18,5 L11.3333168,9.99998762 L18,15 L17,15.9999406 L10.16667,10.8749684 L10,10.9999703 L9.83333003,10.8749684 L3,15.9999406 L2,15 L8.66668317,9.99998762 L2,5 L3,4 L9.83333333,9.125 L10,9 Z"
          />
          <polygon
            fill="#FFF"
            points="7 20 13 20 13 13 20 13 20 7 13 7 13 0 7 0 7 7 0 7 0 13 7 13"
          />
          <polygon
            fill="#CF142B"
            points="8 0 8 8 0 8 0 12 8 12 8 20 12 20 12 12 20 12 20 8 12 8 12 0"
          />
        </g>
        <circle cx={12} cy={12} r={10} stroke={color} strokeWidth={2} />
      </g>
    </svg>
  );
}

export default IcFlagCircularEn;
